// import { configureStore } from '@reduxjs/toolkit';
// import authReducer from './reducers/auth';

// const store = configureStore({
//   reducer: {
//     auth: authReducer
//   }
// });

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux"; // Needed for multiple reducers
import {
	persistStore,
	persistReducer,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage for web

import authReducer from "./reducers/auth";

// Persist configuration
const persistConfig = {
	key: "root",
	storage,
	whitelist: ["auth"], // Only persist the auth slice (good practice)
};

// Your root reducer (you can add more slices later)
const appReducer = combineReducers({
	auth: authReducer,
});

// Wrap with persistReducer
const persistedReducer = persistReducer(persistConfig, appReducer);

// Create the store
const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [
					FLUSH,
					REHYDRATE,
					PAUSE,
					PERSIST,
					PURGE, // ← Critical: ignore PURGE
					REGISTER,
				],
			},
		}),
});

// Export persistor so you can use persistor.purge() on logout
export const persistor = persistStore(store);

export default store;

// import { configureStore } from "@reduxjs/toolkit";
// import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage"; // defaults to localStorage
// import authReducer from "./reducers/auth";

// // Persist config
// const persistConfig = {
// 	key: "root",
// 	storage,
// 	whitelist: ["auth"], // Only persist the auth slice (recommended)
// 	// blacklist: [] // if you want to exclude something
// };

// // Wrap your root reducer
// const rootReducer = {
// 	auth: authReducer,
// };

// const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer)); // You'll need combineReducers

// import { combineReducers } from "redux"; // ← Add this import at top

// // Create store with persisted reducer
// const store = configureStore({
// 	reducer: persistedReducer,
// 	middleware: (getDefaultMiddleware) =>
// 		getDefaultMiddleware({
// 			serializableCheck: {
// 				ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
// 			},
// 		}),
// });

// export const persistor = persistStore(store); // ← Export this too
// export default store;
